import { d as dev } from "../../../chunks/index4.js";
const csr = dev;
const prerender = false;
export {
  csr,
  prerender
};
